import React, { useEffect } from 'react';
import { HeaderContainer } from 'carbon-components-react';
import { EmailNew20, Email20, UserAvatar20, AppSwitcher20, Wikis20, DocumentDownload20, Help20 } from '@carbon/icons-react';
import {
    Header,
    HeaderName,
    HeaderGlobalAction,
    HeaderGlobalBar,
    HeaderPanel,
    Switcher,
    SwitcherItem,
    SwitcherDivider,
    HeaderMenu,
    HeaderMenuButton,
    HeaderNavigation,
    HeaderMenuItem,
    SkipToContent,
    SideNav,
    SideNavItems,
    HeaderSideNavItems,
    TooltipDefinition,
	Modal
} from "carbon-components-react";
import i18n from "../i18n";
import ArrowRight from 'assets/image/ArrowRight.svg';
import callGetApi from "../requests/GetRequests"
import * as Constants from '../requests/URLConstants'
import DOLogo from 'assets/image/DO_logo.svg';
import { Checkmark16 } from '@carbon/icons-react';
import * as configConst from "../config/Constants";
import * as workspaces from '../config/WorkspaceConstants'
import * as urlConstant from '../requests/URLConstants'

var config = require('./../config/appConfig.json');


export const HeaderComponent = (props) => {
    const [SideNavExpanded, setIsSideNavExpanded] = React.useState(false);
    const aoccLabel = i18n.t('manageAutomation.aoccLabel');
    const qualityCheckLabel = i18n.t('manageAutomation.qualityCheckLabel');
    const IBMPlatformName = i18n.t('manageAutomation.IBMPlatformName');
    const openMenu = i18n.t('manageAutomation.openMenu');
    const IBM = i18n.t('manageAutomation.IBM');
    const IBMPlatform = i18n.t('manageAutomation.IBMPlatform');
    const manageSchedule = i18n.t('manageAutomation.manageSchedule');
    const onboardCode = i18n.t('manageAutomation.onboardCode');
    const ManageOperations = i18n.t('manageAutomation.ManageAutomation');
    const RunAutomata = i18n.t('runAutomata.runAutomata');
    const Analytics = i18n.t('manageAutomation.analytics');
    const logoutlabel = i18n.t('pageHeader.navBar.logout');
	const AutomationOperationsUserGuide = i18n.t('userGuide.AutomationOperationsUserGuide');
	const SapOperationsUserGuide = i18n.t('userGuide.SapOperationsUserGuide');
    let languages = [
        {
            id: 'en',
            value: 'English (Default)',
            isSelected: true
        },
        {
            id: 'ja',
            value: 'Japanese',
            isSelected: false
        },
        {
            id: 'es',
            value: 'Spanish',
            isSelected: false
        },
        {
            id: 'pa',
            value: 'Portuguese',
            isSelected: false
        }]       
    const [language, setlanguages] = React.useState(languages);
    const [isUserDetailsExpanded, setIsUserDetailsExpanded] = React.useState(false);
    const [ischangeLanguageExpanded, setIschangeLanguageExpanded] = React.useState(false);
    const [isuserGuideExpanded, setIsuserGuideExpanded] = React.useState(false);
    const [userTask, setUserTask] = React.useState(0);
    const [billingClick, setBillingClicked] = React.useState(false);
	const[pdfView, setPdfView]= React.useState(false);
    // const [isAdmin, setAdmin] = React.useState(true);

    const CHECK_INTERVAL = 300000; // 5 min interval
    let user = JSON.parse(localStorage.getItem('user_name'));

    useEffect(() => {
        getActiveUserTask();
        let id = setInterval(() => {
            getActiveUserTask();
        }, CHECK_INTERVAL);
        return () => clearInterval(id);
    }, []);

    function getRightsforAdmin() {
        let roles = JSON.parse(localStorage.getItem('roles'));
        if (configConst.URL.includes(configConst.unilever)) {
            if (roles && roles.includes("Dashboard_Admin") === true) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    function getBillingRole() {
        let roles = JSON.parse(localStorage.getItem('roles'));
        console.log("roles", roles);
        if (roles && roles.includes("Billing") === true) {
            return true;
        } else {
            return false;
        }
    }

    useEffect(() => {
        language.map((lang) => {
            if (localStorage.i18nextLng === 'ja') {
                i18n.changeLanguage('ja');
                lang.isSelected = localStorage.i18nextLng === lang.id ? true : false;
            }
            if (localStorage.i18nextLng === 'es') {
                i18n.changeLanguage('es');
                lang.isSelected = localStorage.i18nextLng === lang.id ? true : false;
            }
            if (localStorage.i18nextLng === 'en') {
                i18n.changeLanguage('en');
                lang.isSelected = localStorage.i18nextLng === lang.id ? true : false;
            }
            if (localStorage.i18nextLng === 'pa') {
                i18n.changeLanguage('pa');
                lang.isSelected = localStorage.i18nextLng === lang.id ? true : false;
            }
        })
    }, [])



    // var language = [{id: 'en',value:'English (Default)'},{id:'ja',value:'Japanese'},{id:'es',value:'Spanish'},{id:'pa',value:'Portuguese'}]

    function changeLanguage(e) {
        setIschangeLanguageExpanded(!ischangeLanguageExpanded);
        language.map((lang) => {
            if (e.target.id === 'ja') {
                i18n.changeLanguage('ja');
                lang.isSelected = localStorage.i18nextLng === e.target.id && lang.id === e.target.id ? true : false;
            }
            if (e.target.id === 'es') {
                i18n.changeLanguage('es');
                lang.isSelected = localStorage.i18nextLng === e.target.id && lang.id === e.target.id ? true : false;
            }
            if (e.target.id === 'en') {
                i18n.changeLanguage('en');
                lang.isSelected = localStorage.i18nextLng === e.target.id && lang.id === e.target.id ? true : false;
            }
            if (e.target.id === 'pa') {
                i18n.changeLanguage('pa');
                lang.isSelected = localStorage.i18nextLng === e.target.id && lang.id === e.target.id ? true : false;
            }
        })
        window.location.href = "/manage_operations";
    }

  
    function getActiveUserTask() {
        callGetApi(Constants.GETUSERTASKS + true, {
            withCredentials: true,
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic d2JhZG1pbjp3YmFkbWlu',
            },
        }).then(resp => {
            setUserTask(resp.length);
        });
    }

    function clickWorkspace(e) {
        setIsSideNavExpanded(!SideNavExpanded);
        props.workspaces.map(workspace => (
            workspace.isSelected = (workspace.id === e.target.id ? true : false)
        ));
        props.updateWorkspace(e.target.id);
        let urlElements = window.location.href;
        //console.log("Path", urlElements);
        if (!urlElements.includes("manage_operations")) {
            // return (<Redirect to={'/manage_operations'} push={true}/>);
            window.location.href = "/manage_operations";
        }
    };

    function logout(e) {
        callGetApi(Constants.LOGOUTURL, { 'Content-Type': 'application/json' })
            .then(response => {
                //console.log(response);
                return response;
            }).then(resp => {
                let redirect_value = resp.redirect
                if (redirect_value !== null) {
                    window.location.href = redirect_value;
                }

            }).catch((error) => {
                console.error('Error:', error);
            });
    }

    return (
        <>
            <HeaderContainer
                render={({ isSideNavExpanded, onClickSideNavExpand }) => (
                    <Header aria-label={IBMPlatformName}>
                        <SkipToContent />
                        <HeaderMenuButton
                            aria-label={openMenu}
                            onClick={onClickSideNavExpand}
                            isActive={isSideNavExpanded}
                        />
                        <HeaderName prefix="" href={'/homepage'}>
                            <img src={DOLogo} alt="" />
                        </HeaderName>
                        {props.workspace === workspaces.automation_ops ?
                            <>
                                <HeaderNavigation aria-label={IBMPlatform}>
                                    {getRightsforAdmin() ? <HeaderMenuItem isCurrentPage={window.location.pathname === '/qualityCheck'} href={'/qualityCheck'}>{qualityCheckLabel}</HeaderMenuItem> : null}
                                    {(configConst.URL.includes(configConst.unilever)) || configConst.URL.includes(configConst.production) ? null : <HeaderMenuItem isCurrentPage={window.location.pathname === '/manageSchedule'} href={'/manageSchedule'}>{manageSchedule}</HeaderMenuItem>}
                                    {(configConst.URL.includes(configConst.cibc)) || configConst.URL.includes(configConst.production) ? null : <HeaderMenuItem isCurrentPage={window.location.pathname === '/automata'} href={'/automata'}>{RunAutomata}</HeaderMenuItem>}
                                    <HeaderMenuItem isCurrentPage={window.location.pathname === '/analytics'} href={'/analytics'} workspace={props.workspace}>{Analytics}</HeaderMenuItem>
                                    {/* <HeaderMenu aria-label="Dashboard" menuLinkName="Dashboard">
                                    <HeaderMenuItem href="/executionPerformance">Execution Performance</HeaderMenuItem>
                                    <HeaderMenuItem href="/incidentManagement">Incident management efficiency</HeaderMenuItem>
                                    <HeaderMenuItem href="/slaCompliance">SLA Compliance</HeaderMenuItem>
                                    <HeaderMenuItem href="/queueEfficiency">Queue Efficiency</HeaderMenuItem>

                                </HeaderMenu> */}
                                    <HeaderMenuItem isCurrentPage={window.location.pathname === '/manage_operations'} href={'/manage_operations'}>{ManageOperations}</HeaderMenuItem>
                                </HeaderNavigation>
                                <SideNav
                                    aria-label="Side navigation"
                                    expanded={isSideNavExpanded}
                                    isPersistent={false}>
                                    <SideNavItems>
                                        <HeaderSideNavItems>
                                            {getRightsforAdmin() ? <HeaderMenuItem href="/qualityCheck">{qualityCheckLabel}</HeaderMenuItem> : null}
                                            {(configConst.URL.includes(configConst.unilever)) || configConst.URL.includes(configConst.production) ? null : <HeaderMenuItem href="/manageSchedule">{manageSchedule}</HeaderMenuItem>}
                                            {(configConst.URL.includes(configConst.cibc)) || configConst.URL.includes(configConst.production) ? null : <HeaderMenuItem href="/automata">{RunAutomata}</HeaderMenuItem>}
                                            <HeaderMenuItem href="/analytics">{Analytics}</HeaderMenuItem>
                                            <HeaderMenuItem href="/manage_operations">{ManageOperations}</HeaderMenuItem>
                                        </HeaderSideNavItems>
                                    </SideNavItems>
                                </SideNav>
                            </>
                            :
                            props.workspace === workspaces.sap_ops || props.workspace === workspaces.custom_ops ?
                                <>
                                    <HeaderNavigation aria-label={IBMPlatform}>
                                        {props.workspace !== workspaces.custom_ops && <HeaderMenuItem isCurrentPage={window.location.pathname === '/analytics'} href={'/analytics'} workspace={props.workspace}>{Analytics}</HeaderMenuItem>}
                                        <HeaderMenuItem isCurrentPage={window.location.pathname === '/manage_operations'} href={'/manage_operations'}>{ManageOperations}</HeaderMenuItem>
                                    </HeaderNavigation>
                                    <SideNav
                                        aria-label="Side navigation"
                                        expanded={isSideNavExpanded}
                                        isPersistent={false}>
                                        <SideNavItems>
                                            <HeaderSideNavItems>
                                                {props.workspace !== workspaces.custom_ops && <HeaderMenuItem href="/analytics">{Analytics}</HeaderMenuItem>}
                                                <HeaderMenuItem href="/manage_operations">{ManageOperations}</HeaderMenuItem>
                                            </HeaderSideNavItems>
                                        </SideNavItems>
                                    </SideNav>
                                </>
                                : null
                        }

                        <HeaderGlobalBar>                      
                            <HeaderGlobalAction
                              
                                aria-label="doucument download"
                                onClick={() => setBillingClicked(true)}
                            > {getBillingRole() ?
                                <div className="bill-report-icon" >
                                 <TooltipDefinition
                                        direction="bottom"
                                        alignment="bottom"
                                        tooltipText="Download OCC Monthly Report" >
                                        <a href={'/billingReport'}> <DocumentDownload20 color='white' /></a>
                                    </TooltipDefinition> 
                                    
                                </div>: null}							
                            </HeaderGlobalAction>	
													
                            <HeaderGlobalAction
                                aria-label="User Guide"
                                onMouseEnter={() => { setIsuserGuideExpanded(true); setIsSideNavExpanded(false) }}
                                onMouseLeave={() => { setIsuserGuideExpanded(false) }}
                            >
                                <Help20 />
                            </HeaderGlobalAction>                              
                            
                            <HeaderPanel aria-label="User Guide" expanded={isuserGuideExpanded} onMouseLeave={() => { setIsuserGuideExpanded(false) }}
                                onMouseEnter={() => { setIsuserGuideExpanded(true) }}>
                            <Switcher className="user-guide-list">                     
                                  <SwitcherItem href={urlConstant.GETAUTOMATIONGUIDEURL} target='_blank'>{AutomationOperationsUserGuide}</SwitcherItem>                                                                      
								  <SwitcherItem href={urlConstant.GETSAPGUIDEURL} target='_blank'>{SapOperationsUserGuide}</SwitcherItem>  
							 </Switcher>                                                                                         
							 </HeaderPanel> 

                            <HeaderGlobalAction
                                aria-label="Email"
                                onClick={props.getEmailHandler}
                            >
                                {userTask ? <EmailNew20 /> : <Email20 />}
                            </HeaderGlobalAction>
                            {/* added for changeLanguage */}
                            <HeaderGlobalAction
                                aria-label="Change Language"
                                onMouseEnter={() => { setIschangeLanguageExpanded(true); setIsSideNavExpanded(false) }}
                                onMouseLeave={() => { setIschangeLanguageExpanded(false) }}
                            >
                                <Wikis20 />
                            </HeaderGlobalAction>
                            <HeaderPanel aria-label="Change Language" expanded={ischangeLanguageExpanded} onMouseLeave={() => { setIschangeLanguageExpanded(false) }}
                                onMouseEnter={() => { setIschangeLanguageExpanded(true) }}>
                                <Switcher className="workspace-list">
                                    {language.map((item) => (
                                        <SwitcherItem id={item.id} onClick={changeLanguage} isSelected={item.isSelected}>{item.value}{item.isSelected && <span className="workspace-active"><Checkmark16 /></span>} </SwitcherItem>
                                    ))}
                                </Switcher>


                            </HeaderPanel>

                            {/* added for changeLanguage */}
                            <HeaderGlobalAction
                                aria-label="User Avatar"
                                onMouseEnter={() => { setIsUserDetailsExpanded(true); setIsSideNavExpanded(false) }}
                                onMouseLeave={() => { setIsUserDetailsExpanded(false) }}
                            >
                                <UserAvatar20 />
                            </HeaderGlobalAction>
                            {<HeaderGlobalAction
                                aria-label="App Switcher"
                                // isActive
                                onMouseEnter={() => { setIsSideNavExpanded(true); setIsUserDetailsExpanded(false) }}
                                onMouseLeave={() => { setIsSideNavExpanded(false) }}
                            >
                                <AppSwitcher20 />
                            </HeaderGlobalAction>}
                        </HeaderGlobalBar>
                        <HeaderPanel aria-label="Header Panel" expanded={isUserDetailsExpanded} onMouseLeave={() => { setIsUserDetailsExpanded(false) }}
                            onMouseEnter={() => { setIsUserDetailsExpanded(true) }}>
                            <Switcher aria-label="Switcher Container">
                                <SwitcherItem>
                                    {user}
                                </SwitcherItem>
                                <SwitcherItem className="logout">
                                    <div onClick={logout}>{logoutlabel}
                                        <img className="arrow-icon " src={ArrowRight} alt="" />
                                    </div>
                                </SwitcherItem>
                            </Switcher>
                        </HeaderPanel>
                        <HeaderPanel expanded={SideNavExpanded} onMouseLeave={() => { setIsSideNavExpanded(false) }}
                            onMouseEnter={() => { setIsSideNavExpanded(true) }}
                        >
                            <Switcher className="workspace-list">
                                {props.workspaces ? props.workspaces.map(workspace => (
                                    <SwitcherItem id={workspace.id} isSelected={workspace.isSelected} onClick={clickWorkspace}>{workspace.name}{workspace.isSelected && <span className="workspace-active"><Checkmark16 /></span>}</SwitcherItem>
                                )) : ''}
                            </Switcher>
                        </HeaderPanel>
                    </Header>
                )}
            />
        </>
    );
}
